import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ListIcon from "@material-ui/icons/List";
import MapIcon from "@material-ui/icons/Map";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Box from "@material-ui/core/Box";
import IconLabelButton from "./MyButton";
import Grid from "@material-ui/core/Grid";
import Moment from "react-moment";
import MaxWidthDialog from "./TestDialog";
import SuKienChiTietDialog from "./SuKienChiTietDialog";
import Container from "@material-ui/core/Container";
import { sizing, maxHeight } from "@material-ui/system";
import { Height } from "@material-ui/icons";
import Link from "@material-ui/core/Link";
import TrucBanTimKiemControl from "./controls/TrucBanTimKiemControl";
import TrucBanDenEditDialog from "./TrucBanDenEditDialog";
import TrucBanDiEditDialog from "./TrucBanDiEditDialog";

const server = require("../lib/server.js");
const myLib = require("../lib/MyLib.js");
const PhuongThucGui = ["Khác", "Thoại", "Fax", "Email"];
const columns = [
  { field: "id", headerName: "STT", width: 70 },
  { field: "TrucBanID", headerName: "Mã số", width: 80 },
  {
    field: "ChieuDen",
    headerName: "Chiều",
    width: 130,
    renderCell: (params) => {
      return params.getValue("ChieuDen") === true ? "Đến" : "Đi";
    },
  },
  {
    field: "TenNoiGui",
    headerName: "Nơi gửi",
    width: 230,
    renderCell: (params) =>
      params.getValue("ChieuDen") === true
        ? params.getValue("TenNoiGui")
        : params.getValue("TenCoQuan"),
  },
  {
    field: "TenNoiNhan",
    headerName: "Nơi nhận",
    width: 230,
    renderCell: (params) =>
      params.getValue("ChieuDen") === true
        ? params.getValue("TenCoQuan")
        : params.getValue("TenNoiNhan"),
  },

  {
    field: "ThoiGian",
    headerName: "Thời gian",
    width: 130,
    renderCell: (params) => (
      <Moment format="DD-MM-yyyy HH:mm">{params.getValue("ThoiGian")}</Moment>
    ),
  },
  {
    field: "PhuongThuc",
    headerName: "Phương thức",
    width: 130,
    renderCell: (params) => PhuongThucGui[params.getValue("PhuongThuc")],
  },
  { field: "TenSK", headerName: "Sự kiện liên quan", width: 230 },
  { field: "NoiDung", headerName: "Nội dung", width: 200 },

  { field: "NguoiCN", headerName: "Người CN", width: 120 },
  {
    field: "NgayCN",
    headerName: "Ngày CN",
    width: 130,
    renderCell: (params) => (
      <Moment format="DD-MM-yyyy HH:mm">{params.getValue("NgayCN")}</Moment>
    ),
  },
];

class ThongKePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: { Page: 1, PageSize: 10 }, //dieu kien tim kiem hien thoi
      dataRows: [], //danh sach ban ghi
      totalRows: 0, //tong so ban ghi
      open_den_sukien: false, //hien thi form nhap moi su kien
      open_di_sukien: false,
      open_chitiet_sukien: false,
      open_edit_sukien: false, //hien thi form edit su kien
      Editting_TrucBanID: undefined,
      Editting_ChieuDen: false,
    };
  }

  popupComp = undefined;

  componentDidMount() {}
  //call khi user thay doi trang
  handlePageChange = (params) => {
    if (this.callbackSearch) {
      this.callbackSearch(params.page);
    }
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <form noValidate autoComplete="off">
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={
                  server.getServer() + "/pages/TK_01_TongHop_PhoiHopTKCN.aspx"
                }
              >
                01 - Báo cáo tổng hợp tình hình hoạt động phối hợp TKCN
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={server.getServer() + "/pages/TK_02_PhanTichBaoNan.aspx"}
              >
                02 - Báo cáo phân tích thông tin báo nạn
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={
                  server.getServer() +
                  "/pages/TK_03_PhanTichBaoNanTheoThietBi.aspx"
                }
              >
                03 - Báo cáo phân tích thiết bị báo nạn
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={
                  server.getServer() + "/pages/TK_04_PhanTichHoatDongTKCN.aspx"
                }
              >
                04 - Báo cáo phân tích hoạt động TKCN và phối hợp
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={
                  server.getServer() +
                  "/pages/TK_05_PhanTichHoatDongPhoiHop.aspx"
                }
              >
                05 - Báo cáo phân tích hoạt động phối hợp TKCN hàng hải
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={server.getServer() + "/pages/TK_07_TongHop_TruongSa.aspx"}
              >
                07 - Báo cáo tổng hợp tình hình hoạt động TKCN - Trường Sa,Hoàng
                Sa
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={server.getServer() + "/pages/TK_10_TongHop_ChotChan.aspx"}
              >
                10 - Báo cáo tổng hợp tình hình hoạt động phối hợp TKCN khi tàu
                chốt chặn
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={
                  server.getServer() + "/pages/TKCN TK_11_TongHop_QuocTe.aspx"
                }
              >
                11 - Báo cáo phân tích hoạt động phối hợp quốc tế
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={
                  server.getServer() +
                  "/pages/TK_13_TongHop_ThuNhan_TheoNam.aspx"
                }
              >
                13 - Báo cáo tổng hợp thu nhan thong tin theo năm
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={
                  server.getServer() +
                  "/pages/TK_14_TongHop_TaiNan_TheoNam.aspx"
                }
              >
                14 - Báo cáo tổng hợp loại hình tai nạn theo năm
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={
                  server.getServer() + "/pages/TK_15_TongHop_HoTro_TheoNam.aspx"
                }
              >
                15 - Báo cáo tổng hợp cứu nạn hỗ trợ tàu và người theo năm
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={
                  server.getServer() +
                  "/pages/TK_16_TongHop_HoTro_TruongSa_TheoNam.aspx"
                }
              >
                16 - Báo cáo tổng hợp cứu nạn hỗ trợ tàu và người tại Hoàng Sa,
                Trường Sa theo năm
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="inherit"
                target="_blank"
                href={server.getServer() + "/pages/TK_17_TongHop_TauSB.aspx"}
              >
                17 - Báo cáo tổng hợp tình hình hoạt động phối hợp TKCN tàu SB,
                hạn chế III
              </Link>
            </Grid>
          </Grid>
        </form>
      </>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  gridContainer: {
    height: 500,
  },
});

export default withStyles(styles, { withTheme: true })(ThongKePage);
